import React, { useEffect, useState } from 'react'
import { Link, useParams } from "react-router-dom";
import Header from '../BaseComponents/Header';
import FotterMain from '../BaseComponents/FotterMain';
import { blogDetails, eventDetails } from '../../networkCalls';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';
import parse from 'html-react-parser';
import SEO from '../BaseComponents/SEO';

const BlogDetails = () => {
    const { pageSlug } = useParams();
    const [loading, setLoading] = useState(false);
    const [resultData, setResultData] = React.useState([]);
    const blogDetailsAPI = () => {
        var data = new FormData();
        data.append('slug', pageSlug);
        setLoading(true);
        blogDetails(data).then((res) => {
            console.log('dsfdf', res?.data )
            setLoading(false);
            switch (res.data.status) {
                case 1:
                    setResultData(res?.data?.pressDetails)
                    //setErrMessage('');
                    return true;
                case 0:
                    //setErrMessage(res.data.msz);
                    break;
                default:
                    return;
            }
        })
    }
    useEffect(() => {
        blogDetailsAPI();
    }, [pageSlug]);

    return (
        <>
            <SEO
                title={resultData?.title || "Honda India Power Products | Honda Blog"}
                description={resultData?.short_desc || "Honda India Power Blog"}
                name="HIPP - Honda India Power"
                url={`https://www.hondaindiapower.com/${resultData?.slug}`}
                type='Website' />
            <Header />
            {loading ? <><LoadingCellFullPage /></> : <> <div className="post-view__header post-header post-header--has-image">
                <div className=""></div>
                <div className="post-header__body">
                    <div className="post-header__categories">
                        <div className="post-header__categories-list">
                            <div className="post-header__categories-item mb-3"><Link className="post-header__categories-link text-white bgred rounded f12 p-2 pt-1 pb-1" to="/blog">Blog</Link></div>
                        </div>
                    </div>
                    <h3 className="post-header__title">{resultData?.title}</h3>
                    <div className="post-header__meta">
                        <ul className="post-header__meta-list">
                            <li className="post-header__meta-item text-muted">{resultData?.author != '' ? <>By {resultData?.author} on </> : <></>}{resultData?.publishDate}</li>
                        </ul>
                    </div>
                </div>
                <div className="decor decor--type--bottom post-header__decor">
                    <div className="decor__body">
                        <div className="decor__start"></div>
                        <div className="decor__end"></div>
                        <div className="decor__center"></div>
                    </div>
                </div>
            </div>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-9  m-auto'>
                            <div className='post-view__body card rounded-0 border-0 shadow-sm p-4'>
                                <div className="cm-content prscot">
                                    <div><img src={resultData?.image} alt="" className='w-100' /></div>
                                    {/* <div className='mt-4'>{resultData?.description}</div> */}
                                    <div className='mt-4'>{parse(`${resultData?.long_desc}`)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div></>}
            <div style={{ clear: 'both', height: '40px' }}></div>
            <FotterMain />
        </>
    )
}

export default BlogDetails